import { Github, Linkedin, Mail } from 'lucide-react';
import { navLinks } from '../constants';

const Footer = () => {
    return (
        <footer className="relative z-10 bg-black/80 backdrop-blur-md py-12 border-t border-white/10 transition-colors duration-300">
            <div className="container">
                <div className="flex flex-col md:flex-row justify-between items-center gap-8">

                    {/* Brand */}
                    <div className="text-center md:text-left">
                        <h3 className="text-2xl font-bold font-satisfy bg-gradient-to-r from-primary-purple to-secondary-blue bg-clip-text text-transparent mb-2">
                            Tarush Agarwal
                        </h3>
                        <p className="text-gray-400 text-sm">
                            Building digital experiences that matter.
                        </p>
                    </div>

                    {/* Links */}
                    <div className="flex gap-6 flex-wrap justify-center">
                        {navLinks.map((link) => (
                            <a
                                key={link.name}
                                href={link.href}
                                className="text-gray-400 hover:text-primary-purple transition-colors text-sm font-medium"
                            >
                                {link.name}
                            </a>
                        ))}
                    </div>

                    {/* Socials */}
                    <div className="flex gap-4">
                        <a
                            href="https://github.com/tarush10000"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-primary-purple hover:text-white transition-all"
                        >
                            <Github size={20} />
                        </a>
                        <a
                            href="https://www.linkedin.com/in/tarush10000/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-secondary-blue hover:text-white transition-all"
                        >
                            <Linkedin size={20} />
                        </a>
                        <a
                            href="mailto:tarushagarwal2003@gmail.com"
                            className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-red-500 hover:text-white transition-all"
                        >
                            <Mail size={20} />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
